<template>

 <div>
  <nav class="navbar navbar-dark bg-dark">
    <div class="container"> 
      <router-link to="/" class="navbar-brand" name="Inicio">
        <img src="static/img/logo_branco.png" class="logo"  alt="">
      </router-link>
      <!-- <button class="btn btn-outline-secondary" v-on:click="view='lista'" >Lista</button> -->
      <span class="navbar-text mr-auto p-0 align-self-end">
       Calculadora de Medidas Ballare
     </span>
     <router-link to="/carregar-lista" style="margin-right: 50px;">
      <img class="icones-menu" src="static/img/lista.svg"  alt="Carregar lista">
    </router-link>
    <router-link to="/ajustes" style="margin-right: 5px;">
      <img class="icones-menu" src="static/img/ajustes.svg"  alt="Configura Tabela">
    </router-link>
  </div>
</nav>
</div>
</template>

<script>
export default {
  name: 'MenuTopo',
  data () {
    return {
      // msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icones-menu{
  max-width: 38px;
  max-height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/MenuTopo.vue